import baffle from "baffle";

// this is dumb but makes it stubbable for tests
export default baffle;